import { Toast } from "antd-mobile";
import { Awsdk } from "./awsdk-h5";

const sdkh5 = new Awsdk();

/**
 * 如果 version1 > version2 返回 1，
 * 如果 version1 < version2 返回 -1，
 * 除此之外返回 0。
 **/
export const compareVersion = (version1: string, version2: string) => {
  const n = version1.length,
    m = version2.length;
  let i = 0,
    j = 0;
  while (i < n || j < m) {
    let x = 0;
    for (; i < n && version1[i] !== "."; ++i) {
      x = x * 10 + version1[i].charCodeAt(0) - "0".charCodeAt(0);
    }
    ++i; // 跳过点号
    let y = 0;
    for (; j < m && version2.charAt(j) !== "."; ++j) {
      y = y * 10 + version2[j].charCodeAt(0) - "0".charCodeAt(0);
    }
    ++j; // 跳过点号
    if (x !== y) {
      return x > y ? 1 : -1;
    }
  }
  return 0;
};

export function getQueryObject(url: string) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj: any = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

export function removeParam(key: string, sourceURL: string) {
  let rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

export function getDateTime(timestamp: number) {
  const date = new Date(timestamp);
  return `${
    date.getMonth() + 1
  }/${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
}

export function copyToClipboard(str: string) {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
}

export const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const isSDKInited = () => {
  const { h5 = "0", source } = getQueryObject(window.location.href) ?? {};
  // 有source，且source不为app，则表示非悬浮球环境，返回false
  if (source && source !== 'app') return false;
  if (h5 === "1") return true;
  if (isIOS) return Boolean(window?.webkit?.messageHandlers);
  return Boolean(window.awsdk);
};

export class Toasted {
  private toast(msg: string, time: number = 2000, callback?: Function) {
    console.log("isSDKInited", isSDKInited())
    if (isSDKInited()) {
      dispatchSDK("toast", msg);
    } else {
      Toast.show(msg, 2, false);
    }
    if (callback) {
      setTimeout(() => {
        callback();
      }, time);
    }
  }

  show(msg: string, time: number = 2000, callback?: Function) {
    this.toast(msg, time, callback);
  }

  success(msg: string, time: number = 2000, callback?: Function) {
    this.toast(`✅ ${msg}`, time, callback);
  }

  warning(msg: string, time: number = 2000, callback?: Function) {
    this.toast(`❗${msg}`, time, callback);
  }
}

export const dispatchToast = new Toasted();

export function dispatchSDK(func: ISdkTypes, ...args: any) {
  const params = getQueryObject(window.location.href);
  const { h5 = "0" } = params || {};
  let fixedArgs = args;
  if (func === "share") {
    fixedArgs = fixedArgs?.slice(0, 1);
  }
  try {
    // h5 平台
    if (h5 === "1") {
      return sdkh5.dispatch(func, args);
    }
    // ios 平台
    if (isIOS) {
      const notEmptyArgs = fixedArgs.length ? fixedArgs : [""];
      return window.webkit.messageHandlers[func].postMessage(notEmptyArgs);
    }
    // 安卓平台
    return window.awsdk[func](...fixedArgs);
  } catch (err) {}
}

export const hasPremiumWechatShare = () => {
  const { version_name } = getQueryObject(window.location.href);
  if (!version_name) return false;
  const minIosVersion = "1.6.9";
  const minAndoridVersion = "2.4.4";
  const targetVersion = isIOS ? minIosVersion : minAndoridVersion;
  const result = compareVersion(version_name, targetVersion);
  return result !== -1;
};

// remove url parameter
export const removeUrlParameter = (url: string, parameter: string) => {
  const urlParts = url.split("?");
  if (urlParts.length === 1) {
    return url;
  }
  const prefix = encodeURIComponent(parameter) + "=";
  const pars = urlParts[1].split(/[&;]/g);
  // reverse iteration as may be destructive
  for (let i = pars.length; i-- > 0; ) {
    // idiom for string.startsWith
    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
      pars.splice(i, 1);
    }
  }
  return urlParts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
};

/**
 * 基于游戏SDK版本的方法调用
 * @param currentVersion string 当前SDK版本
 * @param minVersions array[] 最低版本要求 [Android, iOS]
 * @param fn Function 调用的方法
 * @param fallBack Function 不满足条件调用的方法
 */

export const checkVersionAndDispatch = (
  currentVersion: string,
  minVersions: string[],
  fn: any,
  fallback: any
) => {
  const [androidMinVersion, iOSMinVersion] = minVersions;
  const minVersion = isIOS ? iOSMinVersion : androidMinVersion;
  if (compareVersion(currentVersion, minVersion) !== -1) {
    // 不低于版本要求，正常调用
    return fn();
  } else {
    // 否则，调用fallback
    return fallback();
  }
};

/**
 * 尝试解析JSON字符串
 * @param jsonStr JSON字符串
 * @returns JSON对象
 */
export const tryParseJSONstr = (jsonStr: string) => {
  let result = {};
  try {
    result = JSON.parse(jsonStr);
  } catch (err) {
    result = {};
  }
  return result;
};

/**
 * 获取SDK基础信息
 * @returns IBasicData
 */
let __basicInfoTimer__: any = null;
export const getBasicInfo = (): Promise<IBasicData> => {
  return new Promise((resolve, reject) => {
    if (isIOS) {
      if (window.basicInfoCallback) {
        // 如果有进行中的任务，则提前结束，并响应空数据
        window.basicInfoCallback?.resolve?.({});
        window.basicInfoCallback = null;
        clearTimeout(__basicInfoTimer__);
      }
      window.basicInfoCallback = {
        resolve,
        reject,
      };
      dispatchSDK("getBasicInfo");
      __basicInfoTimer__ = setTimeout(() => {
        if (window.basicInfoCallback) {
          window.basicInfoCallback?.resolve?.({});
          window.basicInfoCallback = null;
        }
        clearTimeout(__basicInfoTimer__);
      }, 1000);
    } else {
      const data = tryParseJSONstr(dispatchSDK("getBasicInfo")) as IBasicData;
      resolve(data);
    }
  });
};

export function isPhoneNumber(input: string) {
  // 使用正则表达式匹配手机号的模式
  const pattern = /^1[0-9]{10}$/;
  return pattern.test(input);
}

export function isEmail(input: string) {
  // 使用正则表达式匹配邮件地址的模式
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(input);
}